<div class="provider-section-grid provider-address-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">{{ showReviewStatus ? 'Personal Address' : 'Provider Details' }}</h5>
  </div>
  <div class="provider-section-field" [class.half-width]="!showReviewStatus" [class.quarter-width]="showReviewStatus">
    <div class="user-record-field-wrapper">
      <label for="personalAddress1" class="field-label">Street Address</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalAddress1"
          matInput
          type="text"
          placeholder="123 Main Street"
          class="user-record-field-input"
          formControlName="personalAddress1" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('personalAddress1')" />
    </div>
  </div>
  @if (showReviewStatus) {
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="personalAddress2" class="field-label">Street Address 2 (Optional)</label>
        <mat-form-field class="provider-fields">
          <input
            id="personalAddress2"
            matInput
            type="text"
            placeholder="Apt, Suite, etc."
            class="user-record-field-input"
            formControlName="personalAddress2" />
        </mat-form-field>
      </div>
    </div>
  }
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="personalCity" class="field-label">City</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalCity"
          matInput
          type="text"
          placeholder="City"
          class="user-record-field-input"
          formControlName="personalCity" />
      </mat-form-field>
      <cfi-form-inline-error
          [control]="formGroup.get('personalCity')"
          [customErrorMessages]="cityErrorMessages" />
    </div>
  </div>
  <div class="provider-section-field half-width">
    <div class="user-record-field-wrapper">
      <label for="personalState" class="field-label">State</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalState"
          matInput
          type="text"
          placeholder="State"
          class="user-record-field-input"
          formControlName="personalState"
          [matAutocomplete]="stateAuto" />
        <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayStateName">
          @for (state of filteredStates | async; track state) {
            <mat-option [value]="state">{{ state.name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('personalState')" />
    </div>
  </div>
  <div class="provider-section-field quarter-width">
    <div class="user-record-field-wrapper">
      <label for="personalZip" class="field-label">Zip Code</label>
      <mat-form-field class="provider-fields">
        <input
          id="personalZip"
          matInput
          type="text"
          maxlength="5"
          placeholder="12345"
          class="user-record-field-input"
          formControlName="personalZip"
          [attr.aria-describedby]="formGroup.get('personalZip')?.invalid && formGroup.get('personalZip')?.touched ? 'personalZip-error' : null" />
      </mat-form-field>
      <cfi-form-inline-error [control]="formGroup.get('personalZip')" />
    </div>
  </div>
  @if (isPersonalNorthCarolina()) {
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="personalCounty" class="field-label">County</label>
        <mat-form-field class="provider-fields">
          <input
            id="personalCounty"
            matInput
            type="text"
            placeholder="County"
            class="user-record-field-input"
            formControlName="personalCounty"
            [matAutocomplete]="countyAutoPersonal" />
          <mat-autocomplete #countyAutoPersonal="matAutocomplete">
            @for (county of filteredCounties | async; track county.name) {
              <mat-option [value]="county.name">{{ county.name }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('personalCounty')" />
      </div>
    </div>
  }
  @if (!showReviewStatus) {
    <div class="provider-section-field half-width">
      <div class="user-record-field-wrapper">
        <label for="email" class="field-label">Email Address</label>
        <mat-form-field class="provider-fields">
          <input
            id="email"
            matInput
            type="text"
            placeholder="test@example.com"
            class="user-record-field-input"
            formControlName="email"
            [attr.aria-describedby]="formGroup.get('email')?.invalid && formGroup.get('email')?.touched ? 'email-error' : null" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('email')" />
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="phone" class="field-label">Phone Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="phone"
            matInput
            type="text"
            [mask]="'(000) 000-0000'"
            formControlName="phone"
            class="user-record-field-input"
            [dropSpecialCharacters]="false"
            [attr.aria-describedby]="formGroup.get('phone')?.invalid && formGroup.get('phone')?.touched ? 'phone-error' : null" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('phone')" />
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="secondaryPhone" class="field-label">Secondary Phone Number</label>
        <mat-form-field class="provider-fields">
          <input
            id="secondaryPhone"
            matInput
            type="text"
            [mask]="'(000) 000-0000'"
            formControlName="secondaryPhone"
            class="user-record-field-input"
            [dropSpecialCharacters]="false" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('secondaryPhone')" />
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="birthDate" class="field-label">Date of Birth</label>
        <mat-form-field class="provider-fields">
          <input
            id="birthDate"
            matInput
            [matDatepicker]="birthDatePicker"
            (click)="birthDatePicker.open()"
            placeholder="MM/DD/YYYY"
            class="user-record-field-input"
            formControlName="birthDate" />
          <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #birthDatePicker></mat-datepicker>
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('birthDate')" />
      </div>
    </div>
    <div class="provider-section-field quarter-width">
      <div class="user-record-field-wrapper">
        <label for="socialSecurityLast4TherapyPersonal" class="field-label">Last 4 of SSN</label>
        <mat-form-field class="provider-fields">
          <input
            id="socialSecurityLast4TherapyPersonal"
            matInput
            type="text"
            maxlength="4"
            inputmode="numeric"
            autocomplete="off"
            class="user-record-field-input"
            formControlName="socialSecurityLast4"
            [attr.aria-describedby]="formGroup.get('socialSecurityLast4')?.invalid && formGroup.get('socialSecurityLast4')?.touched ? 'socialSecurityLast4TherapyPersonal-error' : null" />
        </mat-form-field>
        <cfi-form-inline-error [control]="formGroup.get('socialSecurityLast4')" />
      </div>
    </div>
  }
</div>
